<template>
  <div>


    <!--        <v-form>-->
    <!--            <v-container>-->
    <v-row>
      <v-col class="col-1" v-if="!isUsedIntoAnotherView">
        <v-dialog v-model="dialog" max-width="500px">
          <template v-slot:activator="{ on }">
            <v-btn fab color="primary" v-on="on">
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field v-model="editedItem.codigo" label="Código"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field v-model="editedItem.descricao"
                                  label="Descrição"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-select
                        v-model="editedItem.departamento_id"
                        label="departamento"
                        :items="departamentos"
                    >
                    </v-select>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col>
                    <v-simple-table>
                      <template v-slot:default>
                        <thead>
                        <tr>
                          <th class="text-left">Filial</th>
                          <th class="text-left" colspan="2">Preço</th>
                        </tr>
                        </thead>
                        <tbody>

                        <tr
                            v-for="(item, index) in editedItem.mercadoriaFilial"
                            :key="item.filial_id"
                        >
                          <td>{{ item.numero }} - {{ item.nome }}</td>
                          <td>
                            <v-text-field
                                v-model="item.preco"
                                prefix="R$"
                                dense
                                autocomplete="false"
                            ></v-text-field>
                          </td>
                          <td v-if="!index">
                            <v-btn
                                @click="repetirPreco(item)"
                                type="button"
                                icon
                                color="blue"
                                title="Repetir valor em todas as filiais"
                            >
                              <v-icon>
                                mdi-transfer-down
                              </v-icon>
                            </v-btn>
                          </td>
                        </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
              <v-btn color="blue darken-1" text
                     @click="save"
                     class="ma-2"
                     :loading="loading"
                     :disabled="loading"
              >Salvar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>

      <v-col>
        <v-card
            v-bind:class="{'float-right': !isUsedIntoAnotherView}"
            outlined
            flat
            height="90"
        >
          <v-card-subtitle class="pa-0 pt-0 pl-1 pb-2">
            <span>Pesquisar</span>
          </v-card-subtitle>
          <v-card-text>
            <v-container class="ma-0 pa-0">
              <v-row>
                <v-col class="col-5 pa-0 pr-2 pl-4">
                  <v-select
                      @change="getFromApi()"
                      class="pa-0"
                      v-model="filters.departamento"
                      :items="departamentos"
                      label="Departamento"
                      outlined
                      dense
                  ></v-select>
                </v-col>

                <v-col class="col-6 pa-0">
                  <form v-on:submit.prevent="getFromApi()">
                    <v-text-field
                        class="pa-0"
                        v-model="filters.quickSearch"
                        outlined
                        autocomplete="off"
                        label="Quick search"
                        placeholder="código ou descrição"
                        :append-icon="'mdi-magnify'"
                        hint="código ou descrição"
                        dense
                    ></v-text-field>
                  </form>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <!--            </v-container>-->
    <!--        </v-form>-->

    <v-data-table
        :show-select="isUsedIntoAnotherView=='tabela-preco'"
        v-model="selectedItems"
        :headers="computedHeaders"
        :items="items"
        item-key="id"
        :options.sync="options"
        :server-items-length="totalItems"
        class="elevation-1"
        :loading="loading"
        loading-text="Carregando..."
        no-data-text="Nenhum registro encontrado"
        dense
        show-current-page="true"
        :footer-props="{
                  showFirstLastPage: true,
                  showCurrentPage: true,
                  'items-per-page-options': [5, 10, 30, 70, 100],
                }"
        :items-per-page="30"
        group-by="departamento"
    >
      <template v-slot:item.actions=" { item }">
        <v-icon
            small
            class="mr-2"
            @click="editItem(item)"
            color="primary"
        >
          mdi-pencil
        </v-icon>
        <v-icon
            small
            @click="deleteItem(item)"
            color="error"
        >
          mdi-delete
        </v-icon>
      </template>

      <!--<editor-fold desc="usado na view de tabelas de preços">-->
      <template
          v-slot:item.mover=" { item }"
          v-if="isUsedIntoAnotherView == 'tabela-preco' && !selectedItems.length"
      >
        <v-btn icon
               small
               color="blue"
               @click="emitItem(item, false)"
        >
          <v-icon>mdi-table-arrow-right</v-icon>
        </v-btn>
      </template>

      <template
          v-slot:item.selecionar=" { item }"
          v-if="isUsedIntoAnotherView == 'timeline'"
      >
        <v-btn icon
               small
               color="blue"
               @click="emitItem(item, false)"
        >
          <v-icon>mdi-toy-brick-outline</v-icon>
        </v-btn>
      </template>

      <template
          v-slot:item.selecionar=" { item }"
          v-if="isUsedIntoAnotherView == 'timeline-modal-busca-mercadoria'"
      >
        <v-btn icon
               small
               color="blue"
               @click="emitItem(item, false)"
        >
          <v-icon>mdi-check</v-icon>
        </v-btn>
      </template>

      <!--</editor-fold> usado na view de tabelas de preços-->

      <!--            <template v-slot:no-data>-->
      <!--                <v-btn color="primary" @click="getFromApi">Reset</v-btn>-->
      <!--            </template>-->
    </v-data-table>

    <!--        <template v-slot:top>-->
    <!--            <v-toolbar flat>-->
    <v-dialog
        v-model="alertDialog"
        max-width="290"
    >
      <v-card>
        <v-card-title class="headline">
          <span class="orange--text">Atenção</span>
        </v-card-title>

        <v-card-text>
          {{ alertDialogText }}
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
              color="primary darken-1"
              text
              @click="alertDialog = false"
          >
            Ok, entendi
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--            </v-toolbar>-->
    <!--        </template>-->

  </div>


</template>

<script>
// import {parameterizeArray} from '../libs/utils'

export default {
  name: 'Mercadoria',
  props: {
    isUsedIntoAnotherView: {
      type: String,
      required: false
    }
  },
  data: () => ({
    items: [],
    totalItems: 0,
    selectedItems: [],
    options: {},
    dialog: false,
    alertDialog: false,
    alertDialogText: "",
    filters: {
      departamento: '',
      quickSearch: '',
    },

    // btn loading
    loader: null,
    loading: false,

    //select de departamentos
    departamentos: [{text: '', value: ''}],
    filiais: [],

    headers: [],
    editedIndex: -1,
    editedItem: {
      codigo: '',
      descricao: '',
      departamento_id: '',
      mercadoriaFilial: [],
    },
    defaultItem: {
      codigo: '',
      descricao: '',
      departamento_id: '',
      mercadoriaFilial: [],
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? 'Novo Item' : 'Edição do Item'
    },

    computedHeaders() {
      let headers = [];

      switch (this.isUsedIntoAnotherView) {
        case 'tabela-preco':
          headers = [
            {
              text: 'Código',
              align: 'start',
              sortable: true,
              value: 'codigo',
              width: '20%',
            },
            {
              text: 'Descrição',
              sortable: true,
              value: 'descricao'
            },
            {
              text: 'Associar',
              value: 'mover',
              sortable: false,
              width: '20%',
            },
          ]
          break;
        case 'timeline':
        case 'timeline-modal-busca-mercadoria':
          headers = [
            {
              text: 'Selecionar',
              value: 'selecionar',
              sortable: false,
              width: '20%',
            },
            {
              text: 'Código',
              align: 'start',
              sortable: true,
              value: 'codigo',
              width: '20%',
            },
            {
              text: 'Descrição',
              sortable: true,
              value: 'descricao'
            },
          ]
          break;
        default:
          headers = [
            {
              text: 'Ações',
              value: 'actions',
              sortable: false,
              width: '10%',
            },
            {
              text: 'Código',
              align: 'start',
              sortable: true,
              value: 'codigo',
              width: '20%',
            },
            {
              text: 'Descrição',
              sortable: true,
              value: 'descricao'
            },
          ]
          break;
      }

      return headers;
    },
  },

  watch: {
    dialog(val) {
      val || this.close()
    },

    options: {
      handler() {
        this.getFromApi();
      },
      deep: true,
    },
    selectedItems: {
      handler() {
        this.emitSelectedItems();
      }
    },
  },

  created() {
    this.getDepartamentosFromApi();
    this.getFiliaisFromApi();
  },

  methods: {
    // async getFromApi() {
    //     this.loading = true;
    //
    //     let response = await axios.get(this.$store.getters.getUsrEndpoint + '/mercadorias');
    //
    //     this.items = response.data.items;
    //     this.totalItems = response.data.totalItems;
    // },
    emitItem(item, askPrice) {
      this.$emit("emitItem", {item: item, askPrice: askPrice});
    },

    emitSelectedItems() {
      this.$emit("emitSelectedItems", this.selectedItems);
    },

    getFromApi() {

      // console.log(parameterizeArray('filters', this.filters));
      // console.log("--- (parameterizeArray('teste')) fim    ------------");
      // console.log("");

      this.loading = true;

      const {sortBy, sortDesc, page, itemsPerPage} = this.options;

      let params = {
        filters: this.filters,
        sortBy: sortBy,
        sortDesc: sortDesc,
        page: page,
        itemsPerPage: itemsPerPage,
      };

      axios.get(this.$store.getters.getUsrEndpoint + '/mercadorias', {params: params})
          .then((response) => {
                this.items = response.data.items;
                this.totalItems = response.data.totalItems;

                this.loading = false;
              }, (error) => {
                console.log(error);
              }
          )
          .catch(error => {
            console.log(error)
            // this.errored = true
          })
          .finally(() => this.loading = false)
      ;
    },

    deleteItem(item) {
      const index = this.items.indexOf(item)
      if (confirm('Tem certeza que quer remover este item?')) {
        this.loading = true;
        this.loader = 'loading';

        axios
            .delete('/mercadorias/' + item.id)
            .then((response) => {
                  this.close();
                  this.dialog = false

                  // this.items.splice(index, 1);
                  // this.totalItems = this.totalItems - 1;
                  this.getFromApi();

                }, (error) => {
                  this.alertDialog = true;
                  // if (error.response.status == 409) {
                  // }
                  this.alertDialogText = "Houve um problema ao remover o registro";
                }
            )
            .catch(error => {
              console.log(error)
              // this.errored = true
            })
            .finally(() => {
              this.loading = false;
              this.loader = null;
            })
        ;
      }
    },

    save() {
      this.loading = true;
      this.loader = 'loading';

      if (this.editedIndex > -1) {
        axios
            .patch('/mercadorias/' + this.editedItem.id, this.editedItem)
            .then((response) => {
                  this.close();

                  // Object.assign(this.items[this.editedIndex], this.editedItem);
                  this.getFromApi();
                }, (error) => {
                  this.alertDialog = true;
                  // if (error.response.status == 409) {
                  // }
                  this.alertDialogText = "Houve um problema ao modificar o registro";
                }
            )
            .catch(error => {
              console.log(error)
              // this.errored = true
            })
            .finally(() => {
              this.loading = false;
              this.loader = null;
            })
        ;

      } else {
        axios
            .post(this.$store.getters.getUsrEndpoint + '/mercadorias', this.editedItem)
            .then((response) => {
                  // this.items = response.data.items;
                  // this.totalItems = response.data.totalItems;

                  this.close();

                  // this.items.push(this.editedItem);
                  // this.totalItems = this.totalItems + 1;
                  this.getFromApi();

                  this.loading = false;
                }, (error) => {
                  this.alertDialog = true;
                  if (error.response.status == 409) {
                    this.alertDialogText = "Já existe um registro com o código informado";
                  }
                }
            )
            .catch(error => {
              console.log(error)
              // this.errored = true
            })
            .finally(() => {
              this.loading = false;
              this.loader = null;
            })
        ;
      }
    },

    getDepartamentosFromApi() {
      axios.get(this.$store.getters.getUsrEndpoint + '/departamentos')
          .then((response) => {
                for (var i in response.data.items) {
                  this.departamentos.push({
                    value: response.data.items[i].id,
                    text: response.data.items[i].codigo + ' - ' + response.data.items[i].descricao,
                  });
                }
              }, (error) => {
                console.log(error);
              }
          )
          .catch(error => {
            console.log(error)
            // this.errored = true
          })
      ;
    },

    getFiliaisFromApi() {
      axios
          .get(this.$store.getters.getUsrEndpoint + '/filiais')
          .then((response) => {
                this.filiais = response.data.items;

                for (const i in this.filiais) {
                  this.editedItem.mercadoriaFilial.push({
                    id: null,
                    preco: '',
                    filial_id: this.filiais[i].id,
                    numero: this.filiais[i].numero,
                    nome: this.filiais[i].nome,
                  });
                }

              }, (error) => {
                console.log(error);
              }
          )
          .catch(error => {
            console.log(error)
            // this.errored = true
          })
      ;
    },

    editItem(item) {
      this.editedIndex = this.items.indexOf(item)
      this.editedItem = Object.assign({}, item)

      //atribui numero e nome
      for (const i in this.filiais) {
        var index = this.editedItem.mercadoriaFilial.map((o) => o.filial_id).indexOf(this.filiais[i].id);

        if (index >= 0) {
          this.editedItem.mercadoriaFilial[index].numero = this.filiais[i].numero;
          this.editedItem.mercadoriaFilial[index].nome = this.filiais[i].nome;
        } else {
          this.editedItem.mercadoriaFilial.push({
            id: null,
            preco: '',
            filial_id: this.filiais[i].id,
            numero: this.filiais[i].numero,
            nome: this.filiais[i].nome,
          });
        }
      }

      this.dialog = true
    },

    close() {
      this.dialog = false
      this.$nextTick(() => {

        this.defaultItem.mercadoriaFilial = [];
        for (const i in this.filiais) {
          this.defaultItem.mercadoriaFilial.push({
            id: null,
            preco: '',
            filial_id: this.filiais[i].id,
            numero: this.filiais[i].numero,
            nome: this.filiais[i].nome,
          });
        }

        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },

    repetirPreco(filial) {
      for (const filiaisKey in this.editedItem.mercadoriaFilial) {
        this.editedItem.mercadoriaFilial[filiaisKey].preco = filial.preco;
      }
    },
  }
}
</script>
